module.exports = __webpack_public_path__ + "img/bg-type01.b505d0c7.png";